import { type JanusCtx, type Row } from './context.js';
import { type TriggerEvent } from '../reactions/trigger-dispatch.js';
import { triggerFamilyPreDraw, runTriggerFamily } from './trigger-executor.js';
import { manaReductionDelta } from '../resources/reduction-guard.js';
import { resourceReductionReaders } from './resource-reduction.js';

const eventOf = (spellLevel: number | null): TriggerEvent => ({ trigger: 'triggers_when_caster_spends_mana', spellLevel });

/** Preview every possible debit before dice; execute only after Mana actually decreases. */
export function manaSpendPreDraw(ctx: JanusCtx, caster: Row, spellLevel: number | null): void {
  if (manaReductionDelta(caster, -1, resourceReductionReaders(ctx)) === 0) return;
  triggerFamilyPreDraw(ctx, caster, eventOf(spellLevel), undefined, caster);
}
export function fireManaSpend(ctx: JanusCtx, caster: Row, before: number, after: number, spellLevel: number | null): void {
  if (after >= before) return;
  runTriggerFamily(ctx, eventOf(spellLevel), caster, caster, [caster], false);
}
